import { ISection } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const SectionService = sdk.getService('SectionService');

export const useSectionsWithPdf = (sectionIds: string[], allSections: ISection[] = []) => {
  const queryKey = ['section', sectionIds, 'files'];

  const { data } = useQuery({
    queryKey,
    queryFn: () => SectionService.findSectionIdsWithPdf(sectionIds),
    enabled: sectionIds.length > 0 && allSections.length > 0
  });

  const validSections = allSections?.filter(section => (data ?? []).includes(section._id));

  return { sectionFiles: validSections };
};
